import React, { useEffect, useMemo, useState } from "react";
import { useSearchParams, Navigate } from "react-router-dom";
import { useLang } from "../context/LanguageContext";
import { ProductCard } from "../components/ProductCard";
import api from "../lib/api";

export default function Shop() {
  const { t, lang, loc } = useLang();
  const [products, setProducts] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [params] = useSearchParams();
  const q = (params.get("q") || "").toLowerCase();

  useEffect(() => {
    api.get("/products").then((r) => setProducts(r.data)).catch(() => {}).finally(() => setLoaded(true));
  }, []);

  const filtered = useMemo(() => {
    if (!q) return products;
    return products.filter((p) =>
      `${p.name_en} ${p.name_ar} ${p.notes_en?.join(" ")} ${p.short_en}`.toLowerCase().includes(q)
    );
  }, [products, q]);

  return (
    <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-16 md:py-24">
      <div className="max-w-2xl mb-16">
        <h1 className="serif text-4xl sm:text-5xl lg:text-6xl leading-tight">{t("shop_title")}</h1>
        <p className="text-[#8A857D] leading-relaxed mt-6">{t("shop_sub")}</p>
        {q && <p className="text-xs uppercase tracking-widest text-[#C49A6C] mt-6">"{q}" — {filtered.length}</p>}
      </div>

      {filtered.length === 0 ? (
        <p className="text-[#8A857D] py-20">No fragrances found.</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-x-8 gap-y-16">
          {filtered.map((p) => (
            <ProductCard key={p.id} product={p} />
          ))}
        </div>
      )}
    </div>
  );
}
